export default {
  mobile_message:
    'Pour une meilleure ergonomie, utilisez un ordinateur pour consulter le schéma interactif.',
};
